import { ColDef, ICellRendererParams } from "ag-grid-community";
import {
  getMetricFrequencyKeyForLocalContext,
  ResourceMetricsCellRenderer,
} from "@/components/pages/common/resources-ag-grid/components/column-defs/column-def-cell-renderers/metrics/ResourceMetricsCellRenderer";
import { ResourceMetricsHeaderComponent } from "@/components/pages/common/resources-ag-grid/components/column-defs/column-def-cell-renderers/metrics/ResourceMetricsHeaderComponent";
import {
  AllPossibleInlineMetrics,
  MetricsKey,
} from "@/components/pages/common/resources-ag-grid/utils/metrics/metricsTypes";
import { getAggregationByMetricType } from "@/components/pages/common/resources-ag-grid/utils/metrics/getMetricsAggregation";
import { getMetricsByFrequency } from "@/components/pages/common/resources-ag-grid/utils/metrics/getMetricsByFrequency";
import { ResourceType } from "@/services/cloudchipr.api";

export const resourceMetricsColumnDefFieldName = "resource.inline_metrics";

export const getResourceMetricsColumnDef = (
  headerName: string,
  metricKey: MetricsKey,
  resourceType: ResourceType,
  headerTooltip?: string,
): ColDef => {
  return {
    field: resourceMetricsColumnDefFieldName,
    headerName: headerName,
    width: 300,
    minWidth: 250,
    maxWidth: 350,
    cellStyle: { height: "100%", padding: 0 },
    headerTooltip,
    headerComponentParams: {
      innerHeaderComponent: ResourceMetricsHeaderComponent,
      innerHeaderComponentParams: { resourceType, metricKey },
    },
    valueGetter: ({ data, ...props }) => {
      const metricsData: AllPossibleInlineMetrics =
        data?.resource?.inline_metrics;

      const key = getMetricFrequencyKeyForLocalContext(metricKey);
      const metricFrequencyValue =
        props?.column?.getColDef().context?.[key] ?? "24h";

      if (!metricFrequencyValue) {
        return "";
      }

      const metricsByFrequency = getMetricsByFrequency(
        metricKey,
        metricsData,
        metricFrequencyValue,
      );

      if (!metricsByFrequency) {
        return "";
      }

      return getAggregationByMetricType(
        metricKey,
        metricsByFrequency,
        metricFrequencyValue,
      );
    },

    cellRenderer: (props: ICellRendererParams) => {
      return <ResourceMetricsCellRenderer {...props} metricKey={metricKey} />;
    },
  };
};
